import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorReturns = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M9.253 6.859 7.577 4.476c-.31-.44-.29-1.09.165-1.493C8.82 2.027 10.342 1.45 12 1.45c1.659 0 3.18.577 4.258 1.533.455.404.475 1.052.165 1.493l-1.527 2.171a5.947 5.947 0 0 0 1.548-.066c.767-.144 1.466-.478 1.956-1.131a.75.75 0 0 1 1.2.9c-.756 1.008-1.8 1.486-2.79 1.688 2.968 2.324 4.563 6.833 4.683 11.626.039 1.55-1.278 2.736-2.83 2.736H5.334c-1.526 0-2.832-1.149-2.834-2.675C2.492 13.691 4.838 8.408 9.253 6.86Zm1.569-.377a8.878 8.878 0 0 1 1.212-.082c.402 0 .793.028 1.17.083.03-.068.067-.133.111-.196L15 3.892c-.77-.575-1.82-.942-3-.942s-2.23.367-3 .942l1.822 2.59ZM4 19.723c0 .59.523 1.177 1.334 1.177h13.33c.825 0 1.344-.604 1.33-1.198-.082-3.269-.893-6.294-2.293-8.452-1.375-2.12-3.265-3.35-5.667-3.35-2.528 0-4.473 1.217-5.846 3.291-1.404 2.122-2.193 5.14-2.188 8.532Z"
    />
    <path
      fill="#F7A600"
      d="M11.496 11.03c.153-.496.854-.496 1.007 0l.56 1.808h1.879c.504 0 .72.64.32.945l-1.543 1.18.575 1.862a.527.527 0 0 1-.823.574L12 16.275 10.529 17.4a.527.527 0 0 1-.823-.574l.575-1.863-1.543-1.179a.527.527 0 0 1 .32-.945h1.88l.558-1.809Z"
    />
  </svg>
);
export default SvgTwoColorReturns;
